// Melinava: Erklärvideo in der Produktgalerie (snippets/mv-erklaervideo.liquid)
if ( typeof customElements.get('mv-erklaervideo') == 'undefined' ) {

  class MvErklaervideo extends HTMLElement {

    connectedCallback() {
      this.video = this.querySelector('video');
      if ( ! this.video ) return;
      this.addSubtitles();
      this.querySelector('[data-mv-ev-play]').addEventListener('click', () => this.playWithSound());

      // Vorschau nur abspielen, solange sie sichtbar ist; mit Ton nur pausieren, wenn sie aus dem Bild geht
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if ( entry.isIntersecting && ! this.withSound ) {
            this.video.play().catch(() => {});
          } else if ( ! entry.isIntersecting ) {
            this.video.pause();
          }
        });
      }, { threshold: .5 });
      this.observer.observe(this);
    }

    addSubtitles() {
      const source = this.querySelector('[data-mv-ev-vtt]');
      if ( ! source || typeof VTTCue === 'undefined' ) return;
      const seconds = stamp => stamp.split(':').reduce((sum, part) => sum * 60 + parseFloat(part.replace(',', '.')), 0);
      const track = this.video.addTextTrack('subtitles', this.dataset.spur || 'Deutsch', document.documentElement.lang || 'de');
      source.textContent.split(/\r?\n\s*\r?\n/).forEach(block => {
        const lines = block.trim().split(/\r?\n/);
        const timing = lines.findIndex(line => line.includes('-->'));
        if ( timing < 0 ) return;
        const [start, end] = lines[timing].split('-->').map(part => seconds(part.trim().split(/\s+/)[0]));
        const text = lines.slice(timing + 1).join('\n').trim();
        if ( ! text ) return;
        const cue = new VTTCue(start, end, text);
        // "align:end" in der Zeitzeile: Kasten unten rechts, damit Beschriftungen unten links frei bleiben
        if ( /align:(end|right)/.test(lines[timing]) ) cue.align = 'end';
        track.addCue(cue);
      });
      // Eigene Untertitel-Box statt der Browser-Darstellung; im Vollbild zeigt der Browser die Spur selbst
      this.caption = document.createElement('div');
      this.caption.className = 'mv-ev__cc';
      this.caption.setAttribute('aria-hidden', 'true');
      this.appendChild(this.caption);
      this.track = track;
      track.mode = 'hidden';
      track.addEventListener('cuechange', () => {
        const cue = track.activeCues && track.activeCues[0];
        this.caption.textContent = cue ? cue.text.replace(/\s*\n\s*/g, ' ') : '';
        this.caption.classList.toggle('mv-ev__cc--rechts', !! cue && cue.align === 'end');
      });
      const isFull = () => document.fullscreenElement === this.video || document.webkitFullscreenElement === this.video;
      const fullscreen = () => {
        if ( this.captionsOff ) return;
        track.mode = isFull() ? 'showing' : 'hidden';
      };
      // Untertitel-Taste der Bedienleiste: aus = Box ausblenden, an = wieder eigene Box
      this.video.textTracks.addEventListener('change', () => {
        if ( track.mode === 'disabled' ) {
          this.captionsOff = true;
          this.caption.textContent = '';
        } else if ( track.mode === 'showing' && ! isFull() ) {
          this.captionsOff = false;
          track.mode = 'hidden';
        }
      });
      document.addEventListener('fullscreenchange', fullscreen);
      document.addEventListener('webkitfullscreenchange', fullscreen);
      this.video.addEventListener('webkitbeginfullscreen', () => { track.mode = 'showing'; });
      this.video.addEventListener('webkitendfullscreen', () => { track.mode = 'hidden'; });
    }

    playWithSound() {
      this.withSound = true;
      this.classList.add('is-playing');
      this.video.loop = false;
      this.video.muted = false;
      this.video.controls = true;
      this.video.currentTime = 0;
      this.video.play().catch(() => {});

      // Untertitel nur über die Bedienleiste heben, solange der Browser sie zeigt (Maus, Antippen, Pause)
      const showControls = () => {
        this.classList.add('mv-ev--controls');
        clearTimeout(this.controlsTimer);
        this.controlsTimer = setTimeout(() => {
          if ( ! this.video.paused ) this.classList.remove('mv-ev--controls');
        }, 2800);
      };
      showControls();
      ['pointermove', 'pointerdown', 'keydown'].forEach(type => this.addEventListener(type, showControls));
      this.addEventListener('mouseleave', () => {
        if ( ! this.video.paused ) this.classList.remove('mv-ev--controls');
      });
      this.video.addEventListener('pause', () => {
        clearTimeout(this.controlsTimer);
        this.classList.add('mv-ev--controls');
      });
      this.video.addEventListener('play', showControls);
    }

  }

  customElements.define('mv-erklaervideo', MvErklaervideo);

}
